export const DEV_ONLY_APP_AUTH_EMU_PATH = process.env.REACT_APP_FBEMU_AUTH;
export const CENTRAL_HUB_API_BASE_PATH =
  process.env.REACT_APP_API_URL ||
  "https://asia-east2-animaetech-central-hub.cloudfunctions.net/api/int";
export const CENTRAL_HUB_API_BASE_EXT_PATH =
  CENTRAL_HUB_API_BASE_PATH.substring(
    0,
    CENTRAL_HUB_API_BASE_PATH.lastIndexOf("/")
  ) + "/ext";
